/* unplugin-vue-components disabled */import { render } from "./wisdom.vue?vue&type=template&id=1c3911bd&scoped=true"
const script = {}

import "./wisdom.vue?vue&type=style&index=0&id=1c3911bd&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@4.9.5__webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3911bd"]])

export default __exports__